import { jwtDecode } from 'jwt-decode';

export function extractUserIdFromAccessToken(token: string): string {
  let decoded: {
    sub: string;
  };
  try {
    decoded = jwtDecode(token);
  } catch (error) {
    return '';
  }
  return decoded?.sub || '';
}
